const translations = {
    headline: {
        type: 'text',
        defaultValue: 'Jakiej firmy szukasz?',
    },
    subheadline: {
        type: 'text',
        defaultValue: 'Znajdź firmę z idealnie dopasowaną ofertą kursów do Twoich potrzeb',
    },
};

export default translations;
